import { put, takeLatest, select, call } from 'redux-saga/effects';

import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

import { formatError } from '../../../libs';
import categoryAPI from '../../api/category';
import searchAPI from '../../api/search';
import { Creators as CategoryCreators } from '../../reducers/category';
import { Creators as GlobalCreators } from '../../reducers/global';
import { Types, Creators as SearchCreators } from '../../reducers/search';
import { getState } from '../../utils/getState';
import getToken from '../../utils/getToken';

function parseToJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}

function* setSearchParams({ params = {} }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const token = yield select(getToken);
    const search = yield call(searchAPI.getSlug, '/busca', {}, siteId);

    if (!search || isEmpty(search)) {
      throw `Página não encontrada`;
    }

    const data = {
      id: search.id,
      url: search.url || null,
      seo: search.seo || {},
      content: search.content || null,
    };

    const searchQuery = {
      sortBy: app.getIn(['config', 'components', 'Category', 'sortBy']),
      limit: app.getIn(['config', 'components', 'Category', 'pagination', 'limit']),
      offset: app.getIn(['config', 'components', 'Category', 'pagination', 'offset']),
      filter: {},
      ...params,
    };

    delete searchQuery.filtro;

    if (params.filtro) {
      const parsedFilter = parseToJson(params.filtro);
      const filter = !isArray(parsedFilter) ? [parsedFilter] : parsedFilter;

      filter.forEach((item) => {
        searchQuery.filter[item.id] = [...(searchQuery.filter[item.id] || []), ...[item]].filter((obj) => !!obj);
      });
    }

    const query = {
      ...searchQuery,
      filter: map(searchQuery.filter, (item) => JSON.stringify(item))
        .join(',')
        .toString(),
    };

    const result = yield call(categoryAPI.getProducts, query, siteId, token);

    const { aggregations = [], _result = {}, products = [] } = result;
    const sidebar = [
      { ...aggregations.find((item) => item.id === 'categoria'), multiple: false },
      {
        ...aggregations.find((item) => item.id === 'segmentoPrincipal'),
        multiple: true,
      },
      {
        ...aggregations.find((item) => item.id === 'marcaProduto'),
        multiple: true,
        expansionShowItems: app.getIn(['config', 'components', 'Category', 'expansionShowItems']),
      },
      {
        ...aggregations.find((item) => item.id === 'tabelaPreco'),
        multiple: true,
        expansionShowItems: app.getIn(['config', 'components', 'Category', 'expansionShowItems']),
      },
      {
        ...aggregations.find((item) => item.id === 'definicao'),
        multiple: true,
        expansionShowItems: app.getIn(['config', 'components', 'Category', 'expansionShowItems']),
      },
    ];

    const filters = {
      sortBy: searchQuery.sortBy,
      sortByOptions: app.getIn(['config', 'components', 'Category', 'sortByOptions']).filter((item) => item.active),
      sidebar,
    };

    yield put(
      CategoryCreators.getCategorySuccess({
        data,
        filters,
        searchQuery,
        products,
        totalProducts: products.length > 0 ? _result.total : 0,
      })
    );
  } catch (error) {
    yield put(GlobalCreators.errorApp(formatError(error)));
    yield put(SearchCreators.searchParamError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SET_SEARCH_PARAMS_REQUEST, setSearchParams);
}
